<template>
	<div class="footer">
		<div class="containner">
			<div class="flex justify-between">
				<div class="footer-left flex">
					<div class="footer-list">
						<div class="footer-list-title">学掌门院线</div>
						<div class="footer-list-text">中国影迷使用得更多的院线平台</div>
						<div class="footer-list-text">学掌门平台打造的<span class="red">"影视神器"</span></div>
						<div class="footer-list-text"><span class="red">60,000</span> 多个专业分类</div>
						<div class="footer-list-text"><span class="red">600,000</span> 多个影视资源</div>
						<div class="footer-list-text"><span class="red">760,000,000</span> 多条影评</div>
						<div class="footer-list-text"><span class="red">38,000</span> 多个影院</div>
					</div>
					
					<div class="footer-list">
						<div class="footer-list-title">关于我们</div>
						<div class="footer-list-text">关于学掌门</div>
						<div class="footer-list-text">隐私政策</div>
						<div class="footer-list-text">院线平台服务协议</div>
						<div class="footer-list-text">网络信息侵权通知指引</div>
						<div class="footer-list-text">学掌门院线服务监督员</div>
						<div class="footer-list-text">网站地图</div>
						<div class="footer-list-text">联系我们</div>
					</div>
					
					<div class="footer-list">
						<div class="footer-list-title">Vip服务</div>
						<div class="footer-list-text">院线攻略 免费体验</div>
						<div class="footer-list-text">影院问答 评估指南</div>
						<div class="footer-list-text">专业咨询 海量片源</div>
						<div class="footer-list-text">偏好设置 随机抽奖</div>
						<div class="footer-list-text">自动评论 账单统计</div>
						<div class="footer-list-text">消费分析 APP下载</div>
						<div class="footer-list-text">诱惑活动 发现更多</div>
					</div>
				</div>
	
				<div class="footer-right flex">
					<div class="footer-list-right">
						<img src='../assets/index_bottom_wechat.png'/>
						<div class="footer-list-title">学掌门APP</div>
						<div class="footer-list-title">扫描立即下载</div>
					</div>
					<div class="footer-list-right">
						<img src='../assets/index_bottom_wechat.png'/>
						<div class="footer-list-title">学掌门院线</div>
						<div class="footer-list-title">订阅号</div>
					</div>
					<div class="footer-list-right">
						<img src='../assets/index_bottom_wechat.png'/>
						<div class="footer-list-title">学掌门院线</div>
						<div class="footer-list-title">官方服务号</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
</script>

<style>
	.footer{margin-top: 20px; padding: 20px 0px; background-color: #3c3c3c; font-size: 12px; color: #c2c2c2; text-align: left;}
	.footer-list{margin-right: 40px;}
	.footer-list-title{margin-bottom: 10px; font-size: 14px;}
	.footer-list-text{margin-bottom: 5px;}
	.footer-list-right{margin-left: 40px;}
	.footer-list-right .footer-list-title{text-align: center; margin-bottom: 0px;}
</style>
